// dibs-css must be imported before any packages that import dibs-css to guarantee dibs-css is
// bundled correctly in DAL.
import 'dibs-css/exports/dibs-css.module.css';

import serverVars from 'server-vars';
import { IntlProvider } from 'dibs-react-intl';
import { createRoot } from 'react-dom/client';
import { QueryRenderer, graphql } from 'react-relay/legacy';
import { getRelayEnvironment } from '../clientRelayEnvironment';
import { NavContextProvider } from './NavContext';

import { type internalQuery } from './__generated__/internalQuery.graphql';

import '../common';
import '../../scss/entries/internal.scss';
import { InternalNav } from './components/Nav/InternalNav';

const navDomElement = document.getElementById('navigation');

function renderNavbar(): void {
    const root = createRoot(navDomElement as HTMLElement);
    const id = serverVars.get('userData.id');
    if (id) {
        root.render(
            <IntlProvider locale="en-US">
                <NavContextProvider>
                    <QueryRenderer<internalQuery>
                        query={graphql`
                            query internalQuery($userId: String!) {
                                viewer {
                                    ...InternalNav_viewer
                                }
                            }
                        `}
                        variables={{ userId: id }}
                        environment={getRelayEnvironment('internal')}
                        render={({ props }) => {
                            const viewer = props?.viewer;
                            if (!viewer) {
                                return null;
                            }
                            return <InternalNav viewer={viewer} />;
                        }}
                    />
                </NavContextProvider>
            </IntlProvider>
        );
    }
}

if (navDomElement) {
    renderNavbar();
}
